import InfoModel from './infoModel'
import { CONSTANT } from '@/constant/index'
import * as Utils from '@/assets/script/utils'

class CacheModel {

  constructor(chatModel, option) {
    this.chatModel = chatModel
    const defaultConfig = {
      key: 'CHAT_CACHE',
      hasSystemTip: true
    }
    this.option = Object.assign(defaultConfig, option)
    this.init()
  }

  init () {
    const store = Utils.getStore(this.option.key)
    if (!store) return
    let data = JSON.parse(store)
    if (this.option.dayLimit) {
      data = this.setTerm(data)
    }
    this.chatModel.infos = data
  }

  add () {
    let initIndex = 0
    let histories = [...this.chatModel.infos]

    histories.forEach((item, index) => {
      if (item.title === CONSTANT.HISTORY_DIVIDING) {
        initIndex = index
        histories.splice(index, 1)
      }
    })

    if (this.chatModel.isRemove) {
      initIndex = initIndex - 1
    }
    // 判断没有新增记录则返回
    if (!histories[initIndex]) return

    if (!this.chatModel.isRemove) {
      let dateStr = histories[initIndex].time
      // IOS兼容转换
      if (Utils.getSystem.isIOS) {
        dateStr = dateStr.replace(/\-/g, '/')
      }
      const date = new Date(dateStr)
      const newDate = Utils.formatDate(date, 'yyyy-MM-dd hh:mm')
      const dateInfo = new InfoModel({
        type: 'SYSTEM, DATE_TIME',
        title: newDate
      })
      histories.splice(initIndex, 0, dateInfo)
    }

    // 过滤系统提示
    if (!this.option.hasSystemTip) {
      histories = histories.filter(item => {
        return item.type !== 'SYSTEM'
      })
    }

    // 增加历史分割提示
    const dividingInfo = new InfoModel({
      type: 'SYSTEM, DATE_TIME',
      title: CONSTANT.HISTORY_DIVIDING
    })
    histories.push(dividingInfo)

    Utils.setStore(this.option.key, histories)
  }

  remove () {
    this.chatModel.clear()
    Utils.removeStore(this.option.key)
  }

  setTerm (data) {
    let endDateStr = data[data.length - 1].time
    // IOS兼容转换
    if (Utils.getSystem.isIOS) {
      endDateStr = endDateStr.replace(/\-/g, '/')
    }
    const date = new Date(endDateStr),
      limitDate = date.setDate(date.getDate() - this.option.dayLimit),
      // 开始时间字符串
      limitDateStr = Utils.formatDate(limitDate, 'yyyy-MM-dd hh:mm')

    return data.filter(item =>
      Utils.isDuringDate(limitDateStr, endDateStr, item.time)
    )
  }

}

export default CacheModel


// WEBPACK FOOTER //
// ./src/model/cacheModel.js